module.exports = __webpack_public_path__ + "static/media/miraji-geet.fceed847.jpg";